// src/components/common/LoadingSpinner.tsx
import React from "react";
import { View, ActivityIndicator, Text } from "react-native";
import { FlickOColors } from "./styles/color";
import { getResponsiveSize } from "./styles/globalStyles";

export const LoadingSpinner = () => (
  <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
    <ActivityIndicator size="large" color={FlickOColors.primary} />
  </View>
);

export const CompactLoadingSpinner = () => (
  <View
    style={{
      height: 40,
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <ActivityIndicator size="small" color={FlickOColors.primary} />
  </View>
);

//transaparent loader
export const LoadingSpinnerTrans = ({ text }: { text?: string }) => (
  <View
    style={{
      position: "absolute",
      backgroundColor: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
      justifyContent: "center",
      alignItems: "center",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 999,
    }}
  >
    <ActivityIndicator size="large" color={FlickOColors.primary} />
    {text && (
      <Text
        style={{
          fontSize: getResponsiveSize(20),
          color: "white",
          marginTop: getResponsiveSize(10),
        }}
      >
        {text}
      </Text>
    )}
  </View>
);

export default LoadingSpinnerTrans;
